<template>
  <v-card>
    <v-toolbar flat>
      <v-toolbar-title>Trips</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-dialog v-model="newTrip" max-width="600px">
        <template v-slot:activator="{ on }">
          <v-btn color="primary" v-on="on">
            <v-icon dark left>pe-7s-plus</v-icon>New trip
          </v-btn>
        </template>

        <v-card>
          <v-card-title>
            <h3>New trip</h3>
          </v-card-title>

          <v-form @submit.prevent="addTrip">
            <v-container>
              <v-text-field
                v-model="newTripName"
                label="Trip name"
                required
                :rules="[v => !!v || 'Required field']"
              ></v-text-field>

              <v-btn type="submit" color="primary">Create trip</v-btn>
            </v-container>
          </v-form>
        </v-card>
      </v-dialog>
    </v-toolbar>

    <v-data-table
      :headers="[
        { text: 'Name', value: 'name' },
        { text: 'Destination', value: 'destination' },
        { text: 'Published', value: 'draft' },
        { text: 'Actions', sortable: false }]"
      hide-actions
      sort-icon="arrow_carrot-up"
      :items="trips"
    >
      <template v-slot:items="props">
        <td>
          <router-link
            :to="{ name: 'backend-trip', params: { id: props.item.id }}"
          >{{ props.item.data.name }}</router-link>
        </td>
        <td>{{ props.item.data.destination }}</td>
        <td>{{ props.item.data.draft | draft }}</td>
        <td>
          <v-btn
            icon
            flat
            color="primary"
            :to="{ name: 'backend-trip', params: { id: props.item.id }}"
          >
            <v-icon>edit</v-icon>
          </v-btn>
          <v-btn icon flat @click="deleteTrip(props.item.id)">
            <v-icon>delete</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { Database } from '@/library/firebase'

export default {
  data () {
    return {
      trips: [],
      newTrip: false,
      newTripName: null
    }
  },
  filters: {
    draft (v) {
      return v ? 'No' : 'Yes'
    }
  },
  methods: {
    getTrips () {
      Database.ref('trips').once('value', data => {
        data.forEach(trip => {
          this.trips.push({
            id: trip.key,
            data: trip.val()
          })
        })
      })
    },
    addTrip () {
      this.newTrip = false

      Database.ref('trips').push({
        name: this.newTripName,
        destinationm: null,
        draft: true,
        shortDescription: null,
        description: null,
        price: 0,
        duration: 1,
        logo: null,
        program: []
      }).then(data => {
        this.$toasted.success('Trip created', { duration: 2000 })

        this.$router.push({ name: 'backend-trip', params: { id: data.key } })
      })
    },
    deleteTrip (id) {
      if (confirm('Do you really want to delete this trip?')) {
        Database.ref('trips').child(id).remove()

        let index = this.trips.findIndex(t => t.id === id)
        this.trips.splice(index, 1)
      }
    }
  },
  created () {
    this.getTrips()
  }
}
</script>

<style>
</style>
